import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { useGraphConfig } from 'helpers/graph';
import utils from 'helpers/utils';
import { Line } from 'react-chartjs-2';

const colours = [
    theme.palette.primary1Color,
    theme.palette.secondary,
    theme.palette.darkOrange,
    theme.palette.irisBlue,
    theme.palette.envy,
    theme.palette.stardust,
    theme.palette.mossGreen,
    theme.palette.yukonGold,
];

const BookingStatsGraph = (props) => {
    const {
        interval,
        rawData,
        selected,
        translate,
    } = props;

    let data = {};

    utils.each(rawData, (item) => {
        if (item.interval !== interval) {
            return;
        }

        data[item.label] = item;
    });

    const genereDataSet = (dataset) => {
        let result = [];

        Object.keys(dataset).forEach((key, index) => {
            const values = dataset[key];

            const item = {
                backgroundColor: colours[index],
                borderCapStyle: 'butt',
                borderColor: colours[index],
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                data: values,
                fill: false,
                label: key,
                lineTension: 0.1,
                pointBackgroundColor: colours[index],
                pointBorderColor: colours[index],
                pointBorderWidth: 2,
                pointHitRadius: 10,
                pointHoverBackgroundColor: colours[index],
                pointHoverBorderColor: colours[index],
                pointHoverBorderWidth: 2,
                pointHoverRadius: 5,
                pointRadius: 1,
            };

            result.push(item);
        });

        return result;
    };

    const fetchData = (data, selected) => {
        const legend = Object.keys(data);
        let datasets = {};

        utils.each(selected, (currency) => {
            let values = [];

            utils.each(data, (item) => {
                let value = 0;

                if (utils.has(item, `${ currency }.total`)) {
                    value = item[currency].total;
                }

                values.push(value);
            });

            datasets[currency] = values;
        });

        return {
            legend: legend,
            datasets: genereDataSet(datasets),
        };
    };

    const dataSet = fetchData(data, selected);

    const tooltipItemLabelCallback = function (tooltipItem) {
        return Number(tooltipItem.yLabel).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    };

    const options = useGraphConfig(tooltipItemLabelCallback);

    return (
        <Card containerStyle={ { padding: '10px 0', width: '100%', margin: '0 0 2rem 0' } }>
            <CardText>
                <div style={ { display: 'block', margin: '0 0 1rem 0', fontSize: '20px', fontWeight: 'bold', textAlign: 'center' } }>
                    { translate('resources.bookingStats.name') }
                </div>

                <div style={ { width: '96%', height: '320px', margin: '0 auto' } }>
                    { dataSet &&
                        <Line
                            data={ {
                                labels: dataSet.legend,
                                datasets: dataSet.datasets,
                            } }
                            options={ options }
                        />
                    }
                </div>
            </CardText>
        </Card>
    );
};

BookingStatsGraph.propTypes = {
    interval: PropTypes.string,
    rawData: PropTypes.object,
    selected: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(BookingStatsGraph);



// WEBPACK FOOTER //
// ./src/pages/bookingStats/list/BookingStatsGraph.js